import { selectAll, setData } from 'js-common';

/**
 * Set `hidden` attribute based on a flag. Also sets `skip-validation` when
 * hidden if there are input children
 *
 * @param {HTMLElement} el - Element to set hidden on.
 * @param {boolean} isHidden - True to set hidden attribute, false to remove it.
 */
export function setHidden(el, isHidden) {
  if (isHidden) {
    el.setAttribute('hidden', '');
  } else {
    el.removeAttribute('hidden');
  }

  // Disable form validation if hidden.
  selectAll(el, 'input').forEach((input) => {
    setData(input, 'skip-validation', isHidden);
  });
}

/**
 * Show a short text that fades out.
 *
 * https://adactio.com/journal/17465
 *
 * @param {Element} element - Node to show feedback above.
 * @param {string} feedbackContent - Feedback text.
 */
export function showFloatingFeedback(element, feedbackContent) {
  const feedback = document.createElement('span');
  feedback.setAttribute('role', 'status');
  feedback.innerHTML = feedbackContent;

  // Any rules that affect dimensions must be set before getBoundingClientRect
  // so just keep all styling in here. Using a class name doesn't apply the
  // styles in time.
  Object.assign(feedback.style, {
    position: 'absolute',
    display: 'inline-block',
    padding: '1px 10px',
    border: '1px solid #c8dd9c',
    background: '#eaf2d9',
    color: '#3c4d1a',
    opacity: 1,
    transition: 'transform 1.2s ease, opacity 0.8s ease',
    transitionDelay: '0s, 0.4s',
    pointerEvents: 'none',
    zIndex: 9999,
  });

  // Add the feedback node 'globally'.
  document.body.appendChild(feedback);

  // Calculate the feedback node's document position.
  const elementRect = element.getBoundingClientRect();
  const feedbackRect = feedback.getBoundingClientRect();
  const x = Math.round(
    elementRect.left +
      window.scrollX +
      elementRect.width / 2 -
      feedbackRect.width / 2,
  );
  // Add a tiny buffer to place it slightly above the element and not right
  // on its edge.
  const y = Math.round(
    elementRect.top + window.scrollY - feedbackRect.height - 3,
  );

  // 'Float out' the feedback and remove it when done. Could possibly use the
  // transitionend event, but then it would have to be throttled if the
  // transition time is different for different prooperties.
  Object.assign(feedback.style, {
    left: `${x}px`,
    top: `${y}px`,
    transform: 'translateY(-10px)',
    opacity: 0,
  });
  setTimeout(() => {
    if (feedback.parentNode) {
      feedback.parentNode.removeChild(feedback);
    }
  }, 1500);
}
